
import Base from './base'

export default {
  name: 'VsTableIndex',
  extends: Base
}
